
export enum LoadingIndicatorsActionTypes {
    ADD_LOADING_INDICATOR = "ADD_LOADING_INDICATOR",
    REMOVE_LOADING_INDICATOR = "REMOVE_LOADING_INDICATOR",
}

type AddLoadingIndicatorAction = {
    type: LoadingIndicatorsActionTypes.ADD_LOADING_INDICATOR,
    payload: { loadingIndicatorUUID: string; }
};

export const addLoadingIndicator = (loadingIndicatorUUID: string): AddLoadingIndicatorAction => ({
    type: LoadingIndicatorsActionTypes.ADD_LOADING_INDICATOR,
    payload: { loadingIndicatorUUID }
});

type RemoveLoadingIndicatorAction = {
    type: LoadingIndicatorsActionTypes.REMOVE_LOADING_INDICATOR,
    payload: { loadingIndicatorUUID: string; }
};

export const removeLoadingIndicator = (loadingIndicatorUUID: string): RemoveLoadingIndicatorAction => ({
    type: LoadingIndicatorsActionTypes.REMOVE_LOADING_INDICATOR,
    payload: { loadingIndicatorUUID }
});


export type LoadingIndicatorsActions =
    AddLoadingIndicatorAction |
    RemoveLoadingIndicatorAction